__webpack_require__.p = "https://festatic.playgami.scopely.com/portal-common/v8_9_0/";